/* @flow weak */
import KeyConstants from 'constants/KeyConstants';

function isNextUnread(e) {
  return e.altKey && e.shiftKey && e.keyCode === KeyConstants.DOWN;
}

function isQuickSwitch(e) {
  return e.metaKey && e.keyCode === KeyConstants.K;
}

export default {
  isNextUnread,
  isQuickSwitch,
};



// WEBPACK FOOTER //
// ./src/lib/KeyboardShortcuts.js